import MarkdownIt from 'markdown-it';
import { isNil } from '../_internal/data';
var md = new MarkdownIt({
    html: false,
    xhtmlOut: false,
    breaks: true,
    langPrefix: 'language-',
    linkify: true,
    typographer: true,
    quotes: '“”‘’',
    highlight: function () { return ''; },
});
var defaultRender = md.renderer.rules.link_open ||
    function (tokens, idx, options, env, self) {
        return self.renderToken(tokens, idx, options);
    };
md.renderer.rules.link_open = function (tokens, idx, options, env, self) {
    var _a;
    var hrefAttrIndex = tokens[idx].attrIndex('href');
    var href = hrefAttrIndex < 0 ? '' : (_a = tokens[idx].attrs) === null || _a === void 0 ? void 0 : _a[hrefAttrIndex][1];
    if (href && !href.startsWith('#')) {
        var targetAttrIndex = tokens[idx].attrIndex('target');
        if (targetAttrIndex < 0) {
            tokens[idx].attrPush(['target', '_blank']);
        }
        else {
            // @ts-ignore
            tokens[idx].attrs[targetAttrIndex][1] = '_blank';
        }
    }
    return defaultRender(tokens, idx, options, env, self);
};
var cleanValue = function (value) {
    if (isNil(value)) {
        return '';
    }
    return value;
};
export var getHTMLFromMarkdown = function (_a) {
    var inline = _a.inline, children = _a.children;
    var value = cleanValue(children);
    if (inline) {
        return md.renderInline(value);
    }
    else {
        return md.render(value);
    }
};
//# sourceMappingURL=withMarkdown.utils.js.map